export interface LatLng {
  lat: number;
  lng: number;
}

export function parsePointCoordinate(geojson: string | null | undefined): LatLng | null {
  if (!geojson?.trim()) {
    return null;
  }
  try {
    const data = JSON.parse(geojson) as { type?: string; coordinates?: number[] };
    if (
      data.type === 'Point' &&
      Array.isArray(data.coordinates) &&
      data.coordinates.length >= 2
    ) {
      const [lng, lat] = data.coordinates;
      if (typeof lat === 'number' && typeof lng === 'number') {
        return { lat, lng };
      }
    }
  } catch {
    return null;
  }
  return null;
}

export function buildPointCoordinate(lat: number | null, lng: number | null): string | null {
  if (lat === null || lng === null || Number.isNaN(lat) || Number.isNaN(lng)) {
    return null;
  }
  return JSON.stringify({ type: 'Point', coordinates: [lng, lat] });
}
